export { default as Credit } from './credit/Credit'
export { default as Date } from './date/Date'
export { default as ImageIllustration } from './image-illustration/ImageIllustration'
export { default as OnTitle } from './on-title/OnTitle'
export { default as RefNew } from './ref-new/RefNew'
export { default as TitleNews } from './title-news/TitleNews'
